import { render, staticRenderFns } from "./ModalRemitos.vue?vue&type=template&id=4ddf2e48"
import script from "./ModalRemitos.vue?vue&type=script&lang=js"
export * from "./ModalRemitos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports